const getitem = (a, b) => a[b];
export default getitem;
